import randomId from 'javascripts/utils/random-id';
import Slider from '../../../javascripts/globals/slider';
import { getOnNavButtonClick } from '../../../javascripts/globals/slider-extensions';

export default class ProcessSlider {
  constructor($el, options) {
    this.$el = $el;
    this.id = options.id || `process-slider${randomId()}`;

    this.initSlider({
      id: this.id,
      ...options,
    });

    this.initNavs();
  }

  initSlider(options) {
    this.slider = new Slider(this.$el, options);
  }

  initNavs() {
    this.$navButtons = this.$el.querySelectorAll('.pagination__item a');

    const onNavButtonClick = getOnNavButtonClick(this.slider);
    this.$navButtons.forEach(($button) => {
      $button.addEventListener('click', onNavButtonClick);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-process-slider').forEach(
    $processSlider => new ProcessSlider($processSlider, {
      id: $processSlider.getAttribute('data-id'),
      sliderFrame: 'process-slider__items',
      sliderItem: 'process-slider__item',
    }),
  );
});
